import { render, staticRenderFns } from "./importfreezestaffs.vue?vue&type=template&id=e1d80904&"
import script from "./importfreezestaffs.vue?vue&type=script&lang=js&"
export * from "./importfreezestaffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports